<template>
  <div>
    <div class="selectBox">
      <el-form ref="paramsList" :model="params">
        <!-- eslint-disable-next-line vue/no-unused-refs -->
        <QS-search maxLine="2" ref="BLM-search">
          <!-- 内容区域-->
          <el-form-item label="车辆ID" prop="carId">
            <el-input
              v-model.trim="params.carId"
              clearable
              placeholder="请输入车辆ID"
              v-number:integer="18"
            />
          </el-form-item>
          <el-form-item label="车牌号" prop="plateNo">
            <el-select
              v-model="params.plateNo"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="请输入"
              :remote-method="remoteMethod"
              :loading="oLoading.fuzzy"
            >
              <el-option
                v-for="item in options3"
                :key="'options3' + item.plateNo"
                :label="item.plateNo"
                :value="item.plateNo"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="保险公司" prop="providerName">
            <el-select
              placeholder="请选择"
              v-model="params.providerName"
              clearable
              filterable
            >
              <el-option label="全部" value="" />
              <el-option
                v-for="(item, index) in options2"
                :key="index"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="保险类型" prop="type">
            <el-select placeholder="请选择" v-model="params.type" clearable>
              <el-option label="全部" value="" />
              <el-option
                v-for="item in insuranceTypeDict"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="保单状态" prop="state">
            <el-select placeholder="请选择" v-model="params.state" clearable>
              <el-option label="全部" value="" />
              <el-option
                v-for="item in insuranceState"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="所属部门" prop="deptIdList">
            <DeptSelect v-model="params.deptIdList" filterable clearable multiple />
          </el-form-item>
          <!-- 按钮区域，slot方式，各个按钮要单独用item包裹-->
          <template slot="moreBtn">
            <el-form-item>
              <el-button
                :loading="oLoading.search"
                type="primary"
                size="small"
                @click="selectBtn"
              >
                查询
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="Reset"> 重置 </el-button>
            </el-form-item>
            <el-form-item>
              <export
                :exportTemplate="exportTemplate"
                filename="保单管理列表.xlsx"
                :params="exportParams"
                v-if="judgePermission('vehicle_insurance_policy_list_export')"
              />
            </el-form-item>
          </template>
        </QS-search>
      </el-form>
    </div>
    <div class="content">
      <Policy ref="Policy"
        :params="this.params"
        @LoadingChange="LoadingChange">
        <el-button
          class="ml16"
          type="primary"
          size="small"
          @click="uploadPolicy"
          v-if="judgePermission('vehicle_insurance_policy_list_batch_create')"
        >
          批量录入保单
        </el-button>
      </Policy>
    </div>
  </div>
</template>
<script>
import { FuzzySearch, getInsuranceCompanyListV2 } from '@/api/domain/cars'
import selectOption from '@/store/dict/selectOptionDict'
import Policy from '../components/policyList.vue'

export default {
  components: {
    Policy,
  },
  data() {
    return {
      oLoading: {
        search: false,
        fuzzy: false,
      },
      exportTemplate: 'InsuranceDetail',
      params: {
        carId: '',
        plateNo: '',
        providerName: '',
        destination: 2,
        pageSize: 10,
        pageNum: 1,
        state: '',
        type: '',
        deptIdList: [],
      },
      options2: [],
      options3: [],
      res: [],
      URL: '',
    }
  },
  mounted() {
    const { plateNo, id, type } = this.$route.query
    this.params.plateNo = plateNo || ''
    // 车辆ID带入默认值直接搜索保险
    this.params.carId = id || ''
    if (plateNo) {
      this.remoteMethod(this.$route.query.plateNo, 2)
    }
    if (type) {
      this.params.type = Number(type)
    }
    this.getProvider()
    this.URL = this.uploadServiceUrl
    this.$refs.Policy.getList()
  },
  methods: {
    // 导入保单信息
    uploadPolicy() {
      this.$router.push({
        path: '/vehicle/newCarInStock/add',
        query: {
          scene: 'insuranceList',
        },
      })
    },
    LoadingChange(val) {
      this.oLoading.search = val
    },
    /* 获取保险公司 */
    async getProvider() {
      const data = await getInsuranceCompanyListV2()
      this.options2 = data.data
    },
    /* 查询 */
    selectBtn() {
      const para = {
        pagination: {
          pageSize: 10,
          pageNum: 1,
        },
      }
      this.$refs.Policy.paginationEvent(para)
    },
    /* 车牌号改变后发送请求 */
    // eslint-disable-next-line vue/no-unused-properties
    SelectChange(id) {
      const res = this.options3.filter((item) => {
        return item.id === id
      })[0]
      this.formLabelAlign.carId = id
      this.formLabelAlign.carModelName = res.modelName
      this.formLabelAlign.plateNo = res.plateNo
    },
    /* 车辆模糊搜索 */
    async remoteMethod(query, num) {
      if (query.length >= 4) {
        this.oLoading.fuzzy = true
        try {
          const { code, data } = await FuzzySearch({
            state: 2,
            plateNo: query,
          })
          this.oLoading.fuzzy = false
          if (code === 1) {
            this.res = data
            this.options3 = this.res
            if (num === 2) {
              this.formLabelAlign.plateNo = this.res[0].plateNo
              this.formLabelAlign.id = this.res[0].id
              this.formLabelAlign.carModelName = this.res[0].modelName
            }
          }
        } catch (error) {
          this.oLoading.fuzzy = false
        }
      }
    },
    /* 重置 */
    Reset() {
      const para = {
        pagination: {
          pageSize: 10,
          pageNum: 1,
        },
      }
      this.$refs.paramsList.resetFields()
      this.$refs.Policy.paginationEvent(para)
    },
  },
  computed: {
    // 保险类型枚举
    insuranceTypeDict() {
      return this.dictParseList(selectOption.insuranceTypeDict)
    },
    // 保单状态枚举
    insuranceState() {
      return this.dictParseList(selectOption.insuranceState)
    },
    exportParams() {
      return this.params
    },
  },
}
</script>
<style lang="less" scoped>
.el-tabs {
  font-size: 14px;
}
.blue {
  color: #2e7eff;
}
.selectBox {
  margin-bottom: 20px;
  .btnText {
    padding-top: 5px;
    font-size: 14px;
    color: #2e7eff;
  }
}
.btn-box {
  font-size: 0;
  .upload-demo {
    margin: 0 8px;
    display: inline-block;
  }
}
.alertBox2 {
  p {
    margin: 0;
  }
}
.addPolicy {
  ::v-deep .el-input--small {
    width: 220px;
  }
}
.editPolicy {
  ::v-deep .el-input--small {
    width: 220px;
  }
}
</style>
